import React from "react";
import { HiOutlineClock, HiOutlineShieldCheck } from "react-icons/hi2";
import { MdOutlineLocalOffer, MdStar, MdGroups, MdEdit, MdSupportAgent } from "react-icons/md";
import "../../asset/css/cabservice.css";

const CabService = () => {
  return (
    <section className="cab-service-container py-4 py-lg-5">
      <div className="container">
        <div className="row align-items-center g-4">
          
          {/* Right Side: Visuals (Moved to top on Mobile for better engagement) */}
          <div className="col-lg-6 order-1 order-lg-2">
            <div className="cab-visual-wrapper position-relative text-center">
              {/* Decorative Background Blob for Depth */}
              <div className="blob-bg"></div>
              
              <img 
                src="https://png.pngtree.com/png-clipart/20230419/original/pngtree-yellow-taxi-car-png-image_9068014.png" 
                alt="Yellow Cab" 
                className="img-fluid cab-main-img animate-float"
              />
              
              {/* Trust Badges - Floating on Desktop, Side-by-Side on Mobile */}
              <div className="trust-badges-container">
                <div className="badge-card rating-badge shadow-sm animate-fade-in">
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <MdStar className="text-warning fs-5" />
                    <span className="fw-bold">4.9/5</span>
                  </div>
                  <div className="text-muted x-small">Rating</div>
                </div>

                <div className="badge-card customer-badge shadow-sm animate-fade-in-delayed">
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <MdGroups className="text-success fs-5" />
                    <span className="fw-bold">10K+</span>
                  </div>
                  <div className="text-muted x-small">Customers</div>
                </div>
              </div>
            </div>
          </div>

          {/* Left Side: Content */}
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="cab-content text-center text-lg-start">
              <h1 className="display-5 fw-bold mb-3">
                Choose Your Perfect <br className="d-none d-md-block" />
                <span className="text-teal">Rental Package</span>
              </h1>
              <p className="text-muted mb-4 lead fs-6">
                Tailored rental packages designed to meet your every need. 
                From weekend getaways to business solutions.
              </p>

              {/* Features Grid */}
              <div className="row g-3 mb-4 text-start">
                {[
                  { icon: <HiOutlineClock />, label: "Flexible Duration", sub: "Daily to yearly", bg: "bg-yellow" },
                  { icon: <HiOutlineShieldCheck />, label: "Full Insurance", sub: "Comprehensive", bg: "bg-green" },
                  { icon: <MdSupportAgent />, label: "24/7 Support", sub: "Always here", bg: "bg-blue" },
                  { icon: <MdOutlineLocalOffer />, label: "Best Rates", sub: "Competitive", bg: "bg-cyan" }
                ].map((feat, index) => (
                  <div className="col-6 col-sm-6" key={index}>
                    <div className="feature-card h-100 p-2 d-flex align-items-center">
                      <div className={`icon-circle ${feat.bg} me-2`}>
                        {feat.icon}
                      </div>
                      <div>
                        <h6 className="fw-bold mb-0 small">{feat.label}</h6>
                        <p className="x-small text-muted mb-0">{feat.sub}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Action Buttons */}
              <div className="d-flex flex-column flex-sm-row gap-3 btn-group-custom">
                <button className="btn btn-teal-main px-4 py-3 fw-bold flex-grow-1">
                  VIEW PACKAGES
                </button>
                <button className="btn btn-outline-dark px-4 py-3 fw-bold d-flex align-items-center justify-content-center flex-grow-1">
                  <MdEdit className="me-2" /> CUSTOMIZE
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CabService;